import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import Button from '../components/ui/Button';
import { Card } from '../components/ui/Card';

export default function Training() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate('/login');
  }, [user, navigate]);

  const trainingModes = [
    {
      title: 'Argument Building',
      description: 'Craft PAEL with rigorous analysis and clear impact.',
      route: '/training/argument',
    },
    {
      title: 'Characterization',
      description: 'Model stakeholders, incentives, and link to arguments.',
      route: '/training/characterization',
    },
    {
      title: 'Refutation',
      description: 'Target the core of analysis and impact. Then example.',
      route: '/training/refutation',
    },
    {
      title: 'Clashes',
      description: 'Spot decisive battlegrounds and choose the right actors.',
      route: '/training/clashes',
    },
    {
      title: 'Modeling',
      description: 'Define key terms first. Add how and examples if needed.',
      route: '/training/modeling',
    },
    {
      title: 'Framing',
      description: 'Set your frame, diagnose theirs, reframe with discipline.',
      route: '/training/framing',
    },
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Training</h1>
          <p className="text-sm text-gray-600">Short, focused drills with clear rubrics and instant feedback.</p>
        </div>
        <Button variant="secondary" onClick={() => navigate('/modules')}>Browse Lessons</Button>
      </div>

      {/* Modes grid */}
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {trainingModes.map((mode) => (
          <Card
            key={mode.title}
            title={mode.title}
            subtitle={mode.description}
            actions={
              <Button size="sm" onClick={() => navigate(mode.route)}>
                Open
              </Button>
            }
          >
            <p className="text-sm text-gray-700">
              Click Open to jump straight into a drill with a realistic motion and rubric-based feedback.
            </p>
          </Card>
        ))}
      </div>
    </div>
  );
}
